import { Column, Entity, ManyToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefInstallationFamily } from './interface/IRefInstallationFamily';
import { IRefMission } from './interface/IRefMission';
import { IRefChapterRubric } from './interface/IRefChapterRubric';

@Entity('ref_installation_family')
export class RefInstallationFamily extends BaseEntity implements IRefInstallationFamily {
  apiMapping = {
      id: 'id',
      name: 'name',
      parentId: {
        fieldName: 'parent',
        type: 'RefInstallationFamily'
      },
      refMissionId: {
        fieldName: 'refMission',
        type: 'RefMission'
      }
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;

  @ManyToOne('RefInstallationFamily')
  parent: IRefInstallationFamily;

  @ManyToOne('RefMission')
  refMission: IRefMission;

  @ManyToMany('RefChapterRubric', 'refInstallationFamilies')
  refChapterRubrics: IRefChapterRubric[];
}
